// extracted by mini-css-extract-plugin
module.exports = {"container":"_0d8c20c","big":"_d7cf3d3","small":"_25c4766","link":"_c6a01b3"};